import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="dossier-pdf-download"
export default class extends Controller {
  connect() {
    // console.log("Dossier PDF download controller connected")
  }

  // Show a loading indicator when the PDF is being generated
  click(event) {
    // Don't show loading state if they're holding Ctrl (opening in a new tab)
    if (event.ctrlKey || event.metaKey) {
      return
    }

    // Show loading state
    const button = this.element
    const originalHtml = button.innerHTML
    
    button.innerHTML = `<i class="fas fa-circle-notch fa-spin me-2"></i> ${I18n.t('loading')}...`
    button.classList.add('disabled')
    
    // Reset the button after the download starts
    setTimeout(() => {
      button.innerHTML = originalHtml
      button.classList.remove('disabled')
    }, 3000)
  }
}